'use strict';

var values = require('../helpers/values');

module.exports = function every(fn) {
  var items = values(this.items);
  return items.every(fn);
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/every.js
// module id = 1653
// module chunks = 2